const MEMORY = new Map();
const MAX_ITEMS = 48;
const STORAGE_PREFIX = 'vthumb:';

function storageKey(videoId, version) {
    return `${STORAGE_PREFIX}${videoId}:${version || '0'}`;
}

function trimMemory() {
    if (MEMORY.size <= MAX_ITEMS) return;
    const first = MEMORY.keys().next().value;
    if (first) MEMORY.delete(first);
}

/** 读取缓存缩略图（先内存后 sessionStorage） */
export function getVideoThumb(videoId, version) {
    const memKey = `${videoId}:${version || '0'}`;
    if (MEMORY.has(memKey)) {
        return MEMORY.get(memKey);
    }
    try {
        const raw = sessionStorage.getItem(storageKey(videoId, version));
        if (raw) {
            MEMORY.set(memKey, raw);
            return raw;
        }
    } catch {
        /* quota / private mode */
    }
    return null;
}

/** 写入缩略图缓存 */
export function setVideoThumb(videoId, version, dataUrl) {
    if (!dataUrl || !videoId) return;
    const memKey = `${videoId}:${version || '0'}`;
    MEMORY.set(memKey, dataUrl);
    trimMemory();
    try {
        sessionStorage.setItem(storageKey(videoId, version), dataUrl);
    } catch {
        /* quota exceeded — 仅保留内存 */
    }
}

/** 从 video 元素截取封面（小图 JPEG） */
export function captureVideoFrame(videoEl) {
    if (!videoEl || videoEl.videoWidth <= 0 || videoEl.videoHeight <= 0) {
        return null;
    }
    const width = 320;
    const height = Math.max(1, Math.round((width * videoEl.videoHeight) / videoEl.videoWidth));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(videoEl, 0, 0, width, height);
    try {
        return canvas.toDataURL('image/jpeg', 0.62);
    } catch {
        return null;
    }
}
